import React from "react";

export default function Spinner() {
  return <i className="fa fa-spinner fa-spin"></i>;
}
